import qs from 'qs';
import request from '@/config/request';

/*
  获取系列列表
  seriesName
*/
export function getSeriesList({ page, pageSize, ...rest }) {
  return request({
    url: `/series/getSeriesList?page=${page}&pageSize=${pageSize}`,
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  获取店铺列表
*/
export function getShopList() {
  return request({
    url: '/brand/getShopList',
    method: 'post',
  });
}

/*
  获取全部品牌分类
*/
export function getAllBrandList() {
  return request({
    url: '/brand/getAllBrandList',
    method: 'post',
  });
}

/*
  添加系列
  seriesName, seriesEnglishName,brandId,seriesDetail,seriesUrl
*/
export function addSeries(rest) {
  return request({
    url: '/series/addSeries',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  删除系列
  id
*/
export function deleteSeries(id) {
  return request({
    url: '/series/deleteSeries',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  获取系列详情
  id
*/
export function getSeries(id) {
  return request({
    url: '/series/getSeries',
    method: 'post',
    data: qs.stringify({ id }),
  });
}

/*
  编辑系列
  id，seriesName, seriesEnglishName，brandId，seriesDetail，seriesUrl
*/
export function updateSeries(rest) {
  return request({
    url: '/series/updateSeries',
    method: 'post',
    data: qs.stringify(rest),
  });
}

/*
  批量上下架
  ids，seriesState
*/
export function updateSeriesUpAndDown(ids, seriesState) {
  return request({
    url: '/series/updateSeriesUpAndDown',
    method: 'post',
    data: qs.stringify({
      ids,
      seriesState,
    }),
  });
}
